import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'

import { toastErrorLog } from '../../../helpers/toastErrorLog'
import { useAuth } from '../../../hooks/useAuth'
import { adjuntoBuilder } from '../../reutilizables/upload/adjuntoBuilder'
import { ModalUpload } from '../../reutilizables/upload/ModalUpload'
import { insertar } from '../../servicios/mensajesService'
import { actualizarItem } from '../../servicios/pedidosService'
import Input from '../../ui/Input'
import styles from './Reclamar.module.css'

const ENTREGA_OBSERVADA = 3

export const Reclamar = ({
  reclamo,
  setReclamo,
  idComprador,
  idVendedor,
  tipoDoc,
  id,
  actualizarMensajes,
  pedido
}) => {
  const { loginDataContext: { idUsuario: usuario } = {} } = useAuth()
  const [adjuntoPendiente, setAdjuntoPendiente] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [texto, setTexto] = useState('')
  const [enviando, setEnviando] = useState(false)

  const volver = () => {
    setReclamo(false)
    setAdjuntoPendiente(null)
    setTexto('')
    setShowModal(false)
  }

  const enviarReclamo = async () => {
    if (texto.trim() === '' && !adjuntoPendiente) {
      toast.error('Debes escribir un mensaje o adjuntar un archivo.')
      return
    }
    setEnviando(true)

    try {
      const mensaje = {
        idMensajePadre: null,
        idUsuarioChat: usuario === idVendedor ? idComprador : idVendedor,
        idUsuarioEmisor: usuario,
        idComprador,
        idVendedor,
        texto: texto.trim(),
        privado: tipoDoc === 'pedido',
        idAdjunto: adjuntoPendiente ? adjuntoPendiente.idAdjunto : null,
        ...(tipoDoc === 'publicacion'
          ? { idPublicacion: id }
          : tipoDoc === 'pedido'
            ? { idPedidoItem: id }
            : tipoDoc === 'presupuesto'
              ? { idPresupuesto: id }
              : {})
      }

      const pedidoActualizado = {
        ...pedido,
        idPedidoItemEstado: ENTREGA_OBSERVADA
      }

      await insertar(mensaje)
      await actualizarItem(pedidoActualizado)
      await actualizarMensajes()
      setReclamo(false)
      setAdjuntoPendiente(null)
      setTexto('')
      toast.success('Reclamo enviado con éxito.')
    } catch (error) {
      const mensaje = `Error al enviar el reclamo.`
      toastErrorLog(error, mensaje, 'Reclamo')
    } finally {
      setEnviando(false)
    }
  }

  const handleToggle = () => setShowModal((prev) => !prev)

  const manejarAdjunto = useCallback(async (data, setAdjunto) => {
    const { dataAdjunto, adjunto } = data
    const previewAdjunto = await adjuntoBuilder(dataAdjunto, adjunto, adjunto.archivo, {
      preview: true
    })
    setAdjunto({ ...previewAdjunto, idAdjunto: adjunto.idAdjunto })
  }, [])

  const getFileIcon = (filename) => {
    if (filename.endsWith('.pdf')) {
      return 'fa-file-pdf-o'
    }
    if (filename.endsWith('.doc') || filename.endsWith('.docx')) {
      return 'fa-file-word-o'
    }
    if (filename.endsWith('.xls') || filename.endsWith('.xlsx')) {
      return 'fa-file-excel-o'
    }
    return 'fa-file-o'
  }

  return (
    <Modal show={reclamo} onHide={() => setReclamo(false)} centered size={'lg'}>
      <Modal.Header closeButton>
        <Modal.Title>
          {' '}
          <h4>Reclamar</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {adjuntoPendiente && (
            <div className={styles.adjuntosContainer}>
              <div className={styles.previewAdjunto}>
                {adjuntoPendiente.contentType?.startsWith('image/') ? (
                  <img src={adjuntoPendiente.url} alt="preview" className={styles.previewImagen} />
                ) : (
                  <a
                    href={adjuntoPendiente.url}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.archivoNombre}
                    title={adjuntoPendiente.nombre}
                  >
                    <i className={`fa ${getFileIcon(adjuntoPendiente.nombre)}`} />
                    <span className={styles.archivoTexto}>{adjuntoPendiente.nombre}</span>
                  </a>
                )}
                <button
                  type="button"
                  className={styles.removeAdjunto}
                  onClick={() => setAdjuntoPendiente(null)}
                >
                  x
                </button>
              </div>
            </div>
          )}
          <div className={styles.inputArea}>
            <button
              type="button"
              className={styles.attachButton}
              aria-label="Adjuntar archivo"
              onClick={() => setShowModal(true)}
            >
              <i aria-hidden="true" className="fa fa-paperclip" />
            </button>

            <Input
              type="text"
              name="texto"
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              className={styles.input}
              placeholder="Escribí tu pregunta"
            />
          </div>
        </div>
        <ModalUpload
          show={showModal}
          onClose={handleToggle}
          idTipo={10}
          idDoc={id}
          idPerfil={usuario}
          onCarga={(data) => manejarAdjunto(data.data, setAdjuntoPendiente)}
        />
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary me-2" disabled={enviando} onClick={enviarReclamo}>
          {enviando ? 'Enviando...' : 'Enviar Reclamo'}
        </button>
        <button className="btn btn-secondary" onClick={volver}>
          Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  )
}

Reclamar.propTypes = {
  reclamo: PropTypes.bool.isRequired,
  setReclamo: PropTypes.func.isRequired,
  idComprador: PropTypes.number.isRequired,
  idVendedor: PropTypes.number.isRequired,
  tipoDoc: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  actualizarMensajes: PropTypes.func.isRequired,
  pedido: PropTypes.object.isRequired
}
